package com.klantenstop.web.data.models.dto.requests.user

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdatePassword(
    @SerialName("old_password")
    val oldPassword: String,
    val password: String,
    @SerialName("repeat_password")
    val repeatPassword: String?
)
